import { render, staticRenderFns } from "./ReadOnlyRemarks.vue?vue&type=template&id=1f176301&scoped=true"
import script from "./ReadOnlyRemarks.vue?vue&type=script&lang=js"
export * from "./ReadOnlyRemarks.vue?vue&type=script&lang=js"
import style0 from "./ReadOnlyRemarks.vue?vue&type=style&index=0&id=1f176301&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f176301",
  null
  
)

export default component.exports